import { Component } from "excalibur";

export class BuildingComponent extends Component {}
